export enum AssetEventJoinStatus {
  None = "ASSET_EVENT_JOIN_STATUS_NONE",
  Pending = "ASSET_EVENT_JOIN_STATUS_PENDING",
  Joined = "ASSET_EVENT_JOIN_STATUS_JOINED",
}
